import React, { useEffect } from 'react';
import { observer } from 'mobx-react';

import './scss/head-pdf.scss';
import moUser from '@/store/user';

interface IProps {
  onetitle?: string;
  twotitle?: string;
}
interface IState {}

const HeadPdf = (props: IProps, state: IState) => {
  const { onetitle, twotitle } = props;
  const { company, phone } = moUser;
  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="index-pdf-head">
      <section className="content">
        <p>{onetitle}</p>
        <b></b>
        <p>{twotitle}</p>
      </section>
      <section className='information'>
        {company || `个人用户: ${phone ? phone.slice(-4) : ''}`}
      </section>
    </section>
  );
};

export default observer(HeadPdf);
